import React from "react";
import Code from "./Code";
import HeroProfile from "./HeroProfile";
import HeroStart from "./HeroStart";

export default function Hero() {
  return (
    <section id='intro' className='section-wrapper'>
      <Code />
      <HeroStart />
    </section>
  );
}
